<template>
  <v-navigation-drawer
    expand-on-hover
    permanent
    app
    elevation="0"
    style="padding-top:64px"
    color="grey lighten-5"
    ref="navbar"
  >
    <v-list nav shaped dense>
      <span v-for="nav in navigation" :key="nav.route">
        <v-list-item router :to="nav.route" v-if="!nav.children">
          <v-list-item-icon>
            <v-icon>{{nav.icon}}</v-icon>
          </v-list-item-icon>
          <v-list-item-title v-if="!nav.children">{{nav.name}}</v-list-item-title>
        </v-list-item>
        <v-list v-else>
          <v-divider></v-divider>
          <v-subheader class="px-0">{{nav.name}}</v-subheader>
          <v-list-item-group color="primary">
            <v-list-item v-for="child in nav.children" :key="child.route" router :to="child.route">
              <v-list-item-icon>
                <v-icon v-text="child.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="child.name"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </span>
    </v-list>
    <v-spacer></v-spacer>
    <template v-slot:append>
      <v-divider></v-divider>
      <v-card
        class="d-flex align-center"
        color="grey lighten-5"
        flat
        tile
        link
        router
        to="/profile"
      >
        <v-row class="ml-2">
          <v-avatar color="primary" size="38">
            <span
              class="white--text headline body-2"
            >{{userInfo.given_name[0].toUpperCase()}}{{userInfo.family_name[0].toUpperCase()}}</span>
          </v-avatar>
        </v-row>
        <v-list-item class="ml-2">
          <v-list-item-content>
            <v-list-item-title class="title caption">{{userInfo.name}}</v-list-item-title>
            <v-list-item-subtitle class="caption">{{userInfo.email}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>
      <v-divider></v-divider>
      <v-list nav>
        <v-list-item @click="logout">
          <v-list-item-icon>
            <v-icon color="error">logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import Roles from "@/router/roles";
export default {
  data() {
    return {
      navigation: [],
      delay: 500
    };
  },

  computed: {
    ...mapState({
      all: state => state.navigation.all,
      superAdmin: state => state.navigation.superAdmin,
      admin: state => state.navigation.admin,
      access: state => state.navigation.access
    }),
    userInfo() {
      return this.$auth.user
        ? this.$auth.user
        : {
            name: "unknown",
            email: "unknown",
            given_name: "unknown",
            family_name: "unknown"
          };
    }
  },
  methods: {
    logout() {
      this.$auth.logout();
    },
    getNavigation() {
      var nav = [...this.all];
      if (this.$auth.getUserRoles().includes(Roles.SuperAdmin)) {
        nav = nav.concat([...this.superAdmin]);
      }
      if (this.$auth.getUserRoles().includes(Roles.Admin)) {
        nav = nav.concat([...this.admin]);
      }
      if (this.$auth.getUserRoles().includes(Roles.Editor)) {
        nav = nav.concat([...this.access]);
      }
      return nav;
    }
  },
  mounted() {
    setInterval(() => {
      if (this.$auth.keycloak.tokenParsed) {
        this.delay = 60000;
        this.navigation = this.getNavigation();
      }
    }, this.delay);
  }
};
</script>
